import formatDistanceToNow from "date-fns/formatDistanceToNow";

export default function fromNowOrNow(a: number) {
  // within 10s, so we don't show "in a few seconds"
  /*
  if (Math.abs(moment().diff(this)) < 10000) {
    return "just now";
  }
  */
  return formatDistanceToNow(new Date(a), { addSuffix: true });
}
